import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { SaleOrderStatus } from '../../../../entities/sale.order/sale.order';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';

@MergeSchema({
    entity: ActivityEntityName.SaleOrder,
    displayName: "Sale Order",
})
export class SaleOrderMergeData {
    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField({
        displayName: "Sale Order Number"
    })
    saleOrderNumber: string;

    @MergeField({
        displayName: "Customer Reference"
    })
    customerRef: string;

    @MergeField()
    date: string;

    @MergeField()
    expiryDate: string;

    @MergeField()
    totalEx?: string;

    @MergeField()
    totalInc?: string;

    @MergeField()
    totalTax?: string;

    @MergeField()
    status: SaleOrderStatus;

    @MergeField()
    createdBy?: string;

    @MergeField()
    createdDate?: string;

    @MergeField()
    jobNumber: string;

    @MergeField()
    workOrderNumber: string;
}

export const SaleOrderMergeSchema = getSchema(SaleOrderMergeData);